module.exports = __webpack_public_path__ + "static/media/14.567126fb.mp3";